import React, { useContext, useEffect } from "react"
import { Grid, Typography } from "@material-ui/core"
import { useFormContext } from "react-hook-form";
import { QuoteContextStore } from "../../../context/QuoteContext/QuoteContext";

const surfaceDict = {
    "ASPH": "Asphalt",
    "CONC": "Concrete",
    "TURF": "Turf/Grass",
    "GRVL": "Gravel",
    "DIRT": "Dirt"
}

const AirportCodeTableView = () => {
    const { airports } = useContext(QuoteContextStore);
    const { reset } = useFormContext();
    const airport = airports[Object.keys(airports)[0]]
    const isEmpty = !airport.name || !airport.state || !airport.city || !airport.runway_elevation || !airport.runway_length || !airport.runway_surface;

    useEffect(() => {
        reset(airport)
    }, [airport])
    
    return ( !isEmpty && <Grid container item xs={12} sm={12} lg={6} spacing={2}>
                    <Grid justifyContent="space-between" container item xs={12}>
                        <Typography variant="h4" className="grey bold margin-right-large">Aiport name</Typography>
                        <div>{airport?.name}</div>
                    </Grid>
                    <Grid container justifyContent="space-between" item xs={12}>
                        <Typography variant="h4" className="grey bold margin-right-large">Aiport state</Typography>
                        <div>{airport?.state}</div>
                    </Grid>
                    <Grid container justifyContent="space-between" item xs={12}>
                        <Typography variant="h4" className="grey bold margin-right-large">Aiport city</Typography>
                        <div>{airport?.city}</div>
                    </Grid>
                    <Grid container justifyContent="space-between" item xs={12}>
                        <Typography variant="h4" className="grey bold margin-right-large">Field elevation (feet)</Typography>
                        <div>{airport?.runway_elevation}</div>
                    </Grid>
                    <Grid container justifyContent="space-between" item xs={12}>
                        <Typography variant="h4" className="grey bold margin-right-large">Runway length</Typography>
                        <div>{airport?.runway_length}</div>
                    </Grid>
                    <Grid container justifyContent="space-between" item xs={12}>
                        <Typography variant="h4" className="grey bold margin-right-large">Runway surface</Typography>
                        <div>{surfaceDict[airport?.runway_surface]}</div>
                    </Grid>
                </Grid> 
    )
}

export default AirportCodeTableView;